const getMeridianStatus = (time: string): { isAm: boolean; isMeridian: boolean; isPm: boolean } => {
  const [hour] = time.split(':').map((timeChunk) => parseInt(timeChunk));
  const isAm = time.toLowerCase().includes('a');
  const isPm = time.toLowerCase().includes('p');
  return {
    isAm,
    isPm,
    isMeridian: (isAm || isPm) && hour <= 12,
  };
};

export default getMeridianStatus;
